import React, { useEffect } from 'react';
import { Box, Typography, Alert, CircularProgress, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../authentication/store/authStore';

export const UniversityAdminManageWrapper: React.FC = () => {
  const { userSession, currentTenant } = useAuthStore();
  const navigate = useNavigate();

  // Get the tenant ID from the current tenant context
  const tenantId = currentTenant?.id || userSession?.currentTenantId;

  useEffect(() => {
    // Once we have the tenant ID, navigate to the proper university management URL
    // IMPORTANT: Use /app/manage/ prefix to avoid legacy redirect loop from AppRouter
    if (tenantId) {
      navigate(`/app/manage/universities/${tenantId}/institutes`, {
        replace: true,
      });
    }
  }, [tenantId, navigate]);

  // Handle loading state
  if (!userSession) {
    return (
      <Container maxWidth={false} disableGutters>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading your management page...</Typography>
        </Box>
      </Container>
    );
  }

  // Handle no tenant assignment state
  if (!tenantId) {
    return (
      <Container maxWidth={false} disableGutters>
        <Alert severity="warning">
          <Typography variant="h6">No University Assignment</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            You are not currently assigned to any university. Please contact your system
            administrator to get assigned to a university.
          </Typography>
        </Alert>
      </Container>
    );
  }

  // During navigation, show loading state
  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Redirecting to your management page...</Typography>
      </Box>
    </Container>
  );
};
